import { WORK_ORDER_STATUS } from "constants/index";
import type { WorkOrderStatus } from "types";

export const WORK_ORDER_STATUS_LABEL: Record<WorkOrderStatus, string> = {
  [WORK_ORDER_STATUS.PENDING]: "Pendiente",
  [WORK_ORDER_STATUS.IN_PROCESS]: "En proceso",
  [WORK_ORDER_STATUS.FINISHED]: "Finalizada",
  [WORK_ORDER_STATUS.CONFIRMED]: "Confirmada",
};

export type WorkOrderOperatorStatus = Exclude<
  WorkOrderStatus,
  typeof WORK_ORDER_STATUS.FINISHED
>;

export const OPERATOR_TABS: { status: WorkOrderOperatorStatus; label: string }[] = [
  { status: WORK_ORDER_STATUS.PENDING, label: "Pendientes" },
  { status: WORK_ORDER_STATUS.IN_PROCESS, label: "En proceso" },
  { status: WORK_ORDER_STATUS.CONFIRMED, label: "Confirmadas" },
];

export const STATUS_COLOR: Record<WorkOrderStatus, 'error' | 'warning' | 'success' | 'secondary'> = {
  [WORK_ORDER_STATUS.PENDING]: 'error',
  [WORK_ORDER_STATUS.IN_PROCESS]: 'warning',
  [WORK_ORDER_STATUS.FINISHED]: 'success',
  [WORK_ORDER_STATUS.CONFIRMED]: 'secondary',
};
